import { axiosInstance, CustomResponseFormat } from "api/instance";
import { DataState } from "../recoil/onboardingDataAtom";

export const ONBOARDING_DOMAIN = "onboarding";

export const ONBOARDING_PAGE_SAVE_ENDPOINT = "page/save";
export const ONBOARDING_PAGE_DATA_SAVE_ENDPOINT = "page-data/save";
export const ONBOARDING_LAST_PAGE_LOAD_ENDPOINT = "page-last/load";
export const ONBOARDING_DATA_SAVE_ENDPOINT = "data/save";

export interface OnboardingPageId {
  pageId?: string;
}

export interface OnboardingData {
  resultText?: string;
}

export const onboardingApi = {
  savePage: (pageId: string) =>
    axiosInstance.post<void>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_PAGE_SAVE_ENDPOINT}`,
      { pageId: pageId }
    ),

  savePageData: (pageId: string, data: DataState) =>
    axiosInstance.post<void>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_PAGE_DATA_SAVE_ENDPOINT}`,
      { pageId: pageId, data: JSON.stringify(data) }
    ),

  loadLastPage: () =>
    axiosInstance.get<CustomResponseFormat<OnboardingPageId>>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_LAST_PAGE_LOAD_ENDPOINT}`
    ),

  saveOnboardingData: (data: OnboardingData) =>
    axiosInstance.post<void>(
      `${ONBOARDING_DOMAIN}/${ONBOARDING_DATA_SAVE_ENDPOINT}`,
      { resultText: data.resultText }
    ),
};